import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const useNewPostStore = create(
  devtools(
    (set) => ({
      //===============
      //ALL POST FIELDS
      //===============

      //---Payment Section---
      swapType: 'toppingUp',
      amount: '',

      //---Item owned section---
      ownedItemCategory: 'cellphone',
      ownedItemName: '',
      ownedItemColor: '',
      ownedItemRam: '',
      ownedItemImages: [],
      ownedItemGraphicsCard: '',
      ownedItemStorage: '',
      ownedItemBattery: '',
      ownedItemCondition: '',
      ownedItemDefects: '',
      ownedItemAccessories: '',
      ownedItemProcessor: '',
      ownedItemComputerType: '',

      //---Item wanted section---
      wantedItemCategory: 'cellphone',
      wantedItemName: '',
      wantedItemColor: '',
      wantedItemRam: '',
      wantedItemImages: [],
      wantedItemGraphicsCard: '',
      wantedItemStorage: '',
      wantedItemBattery: '',
      wantedItemCondition: '',
      wantedItemDefects: '',
      wantedItemAccessories: '',
      wantedItemProcessor: '',
      wantedItemComputerType: '',

      //---Location section---
      locationChoiceValue: 'default-location',
      defaultDistrict: '',
      defaultCity: '',
      location: null,
      district: '',
      city: '',
      customDistrict: '',
      customCity: '',
      // Store the original default location for toggling
      originalDefaultLocation: '',

      //---Contact section---
      callOption: true,
      whatsAppOption: false,
      emailOption: false,
      fbMessengerOption: false,
      smsOption: '',

      //---Additional info section---
      additionalInfo: '',

      //---Images post id section---
      imagesPostId: '',

      //===================
      //UPDATE STORE METHOD
      //===================
      updateField: (field, value) =>
        set((state) => {
          // Special handling for location logic
          if (field === 'locationChoiceValue') {
            if (value === 'default-location') {
              // Switch to default: use originalDefaultLocation if available
              return {
                ...state,
                locationChoiceValue: value,
                location:
                  state.originalDefaultLocation ||
                  `${state.defaultDistrict}, ${state.defaultCity}`,
                district: state.defaultDistrict,
                city: state.defaultCity,
              };
            } else if (value === 'custom-location') {
              // Switch to custom: use custom fields
              return {
                ...state,
                locationChoiceValue: value,
                location:
                  state.customDistrict && state.customCity
                    ? `${state.customDistrict}, ${state.customCity}`
                    : '',
                district: state.customDistrict,
                city: state.customCity,
              };
            }
          }
          // If customDistrict or customCity changes, update location if in custom mode
          if (
            (field === 'customDistrict' || field === 'customCity') &&
            state.locationChoiceValue === 'custom-location'
          ) {
            const newCustomDistrict =
              field === 'customDistrict' ? value : state.customDistrict;
            const newCustomCity =
              field === 'customCity' ? value : state.customCity;
            return {
              ...state,
              [field]: value,
              location:
                newCustomDistrict && newCustomCity
                  ? `${newCustomDistrict}, ${newCustomCity}`
                  : '',
              district: newCustomDistrict,
              city: newCustomCity,
            };
          }
          // If defaultDistrict or defaultCity changes, update location if in default mode
          if (
            (field === 'defaultDistrict' || field === 'defaultCity') &&
            state.locationChoiceValue === 'default-location'
          ) {
            const newDefaultDistrict =
              field === 'defaultDistrict' ? value : state.defaultDistrict;
            const newDefaultCity =
              field === 'defaultCity' ? value : state.defaultCity;
            const newDefaultLocation = `${newDefaultDistrict}, ${newDefaultCity}`;
            return {
              ...state,
              [field]: value,
              location: newDefaultLocation,
              originalDefaultLocation: newDefaultLocation,
              district: newDefaultDistrict,
              city: newDefaultCity,
            };
          }
          // Default update
          return {
            ...state,
            [field]: value,
          };
        }),

      //=====================================
      //RESET FIELDS AFTER ITEM OPTION CHANGE
      //=====================================
      resetOwnedItem: () =>
        set({
          ownedItemName: '',
          // ownedItemCategory: '',
          ownedItemColor: '',
          ownedItemRam: '',
          ownedItemImages: [],
          ownedItemGraphicsCard: '',
          ownedItemStorage: '',
          ownedItemBattery: '',
          ownedItemCondition: '',
          ownedItemDefects: '',
          ownedItemAccessories: '',
          ownedItemProcessor: '',
          ownedItemComputerType: '',
        }),

      resetWantedItem: () =>
        set({
          wantedItemName: '',
          // wantedItemCategory: '',
          wantedItemColor: '',
          wantedItemRam: '',
          wantedItemImages: [],
          wantedItemGraphicsCard: '',
          wantedItemStorage: '',
          wantedItemBattery: '',
          wantedItemCondition: '',
          wantedItemDefects: '',
          wantedItemAccessories: '',
          wantedItemProcessor: '',
          wantedItemComputerType: '',
        }),

      //============================
      //RESET STORE AFTER SUBMISSION
      //============================
      resetPost: () =>
        set({
          //---Payment Section---
          swapType: 'toppingUp',
          amount: '',

          //---Item owned section---
          ownedItemCategory: 'cellphone',
          ownedItemName: '',
          ownedItemColor: '',
          ownedItemRam: '',
          ownedItemImages: [],
          ownedItemGraphicsCard: '',
          ownedItemStorage: '',
          ownedItemBattery: '',
          ownedItemCondition: '',
          ownedItemDefects: '',
          ownedItemAccessories: '',
          ownedItemProcessor: '',
          ownedItemComputerType: '',

          //---Item wanted section---
          wantedItemCategory: 'cellphone',
          wantedItemName: '',
          wantedItemColor: '',
          wantedItemRam: '',
          wantedItemImages: [],
          wantedItemGraphicsCard: '',
          wantedItemStorage: '',
          wantedItemBattery: '',
          wantedItemCondition: '',
          wantedItemDefects: '',
          wantedItemAccessories: '',
          wantedItemProcessor: '',
          wantedItemComputerType: '',

          //---Location section---
          locationChoiceValue: 'default-location',
          defaultDistrict: '',
          defaultCity: '',
          location: null,
          district: '',
          city: '',
          customDistrict: '',
          customCity: '',

          //---Contact section---
          callOption: true,
          whatsAppOption: false,
          emailOption: false,
          fbMessengerOption: false,
          smsOption: '',

          //---Additional info section---
          additionalInfo: '',

          //---Images post id section---
          imagesPostId: '',
        }),

      //==================
      //SUBMIT POST METHOD
      //==================
      submitPost: async () => {
        const state = useNewPostStore.getState();
        console.log(state);
        state.resetPost();
      },
    }),
    {
      name: 'New Post Store',
    }
  )
);

export default useNewPostStore;
